export default __webpack_public_path__ + "static/media/Roland Garros.7f3a30bf.jpg";